import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { SignInButton } from "../ui-components/SignInButtoncopy";
import { callMsGraph } from "../utils/MsGraphApiCall";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Routes, Route, Link as RouterLink, Navigate, useNavigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { MsalProvider, useIsAuthenticated, useMsal} from "@azure/msal-react";
import { Button, ButtonGroup, Typography, AppBar, Box, Toolbar } from "@mui/material";
import { HashRouter as HashRouter, BrowserRouter as Router } from 'react-router-dom';
import {listJobs} from '../api/api'; // Adjust the path as necessary
import ListJobs from './ListJobs';
import CreateJob from './CreateJob';
import GloriaMrio from './GloriaMrio';
import Metadata from './Metadata';
import Guidelines from './Guidelines';
import GuidelineCalculator from './guideline_calculator';
import ContactUs from './ContactUs';
import CreateJobHandler from './CreateJob';
import { SignOutButton } from "../ui-components/SignOutButton";

const FootprintCalculator = () => {
  const [activeTab, setActiveTab] = useState('tab1');
  const [jobs, setJobs] = useState([]);
  const [jobId, setJobId] = useState(null); // Keep only one declaration of jobId
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleUpload = () => {
    setActiveTab('tab3'); // Set tab1 when the button is clicked
  };
  const resources = [
    { href: "https://wedocs.unep.org/handle/20.500.11822/44825", src: "/carbon2.png", alt: "Carbon Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46449", src: "/energy2.png", alt: "Energy Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46450", src: "/land2.png", alt: "Land Icon" },
    { href: "https://wedocs.unep.org/handle/20.500.11822/44824", src: "/material2.png", alt: "Material Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46451", src: "/water2.png", alt: "Water Icon" },
  ];
  const tabs = [
    { id: 'tab1', label: 'Guidelines' },
    { id: 'tab2', label: 'Create Job' },
    { id: 'tab3', label: 'View Jobs' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'tab1':
        return (
          <div className="container-fluid">
            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                  .container-fluid {
                    padding-right: 0 !important;
                    padding-left: 0 !important;
                  }
                  .home-banner img {
                    display: block;
                    margin: 0 auto;
                  }
                  body {
                    font-family: 'Roboto', sans-serif;
                  }
                  p {
                    text-align: left; 
                  }
                `}
            </style>  
            <div className="container" style={{paddingBottom: '2em'}}>         
            <GuidelineCalculator/>
            </div>
          </div>
        );     
      case 'tab3':
          return (
            <div className="container-fluid">
              <style>
                  {`
                  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                  body {
                    font-family: 'Roboto';
                  }
                    .container-fluid {
                      padding-right: 0 !important;
                      padding-left: 0 !important;
                    }
                    .home-banner img {
                      display: block;
                      margin: 0 auto;
                    }
                  `}
              </style>
              <div className="container job-list" style={{paddingBottom: '2em'}}>
              <ListJobs />
              </div>
            </div>
          );        
      case 'tab2':
        return (
          <div className="container-fluid">
            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                body {
                  font-family: 'Roboto';
                }
                  .container-fluid {
                    padding-right: 0 !important;
                    padding-left: 0 !important;
                  }
                  .home-banner img {
                    display: block;
                    margin: 0 auto;
                  }
                `}
            </style>
            <div className="container" style={{paddingBottom: '2em'}}>
            <CreateJob setActiveTab={setActiveTab}/>              
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid">      
        <section id="calculator" className="my-5 container">
          <div className="card-body d-flex flex-column align-items-center">
            {/* Navigation Tabs */}
            <div className="w-100">        
              <ul className="nav nav-tabs justify-content-center">
                {tabs.map((tab) => (<li className="nav-item" key={tab.id}><button className={`nav-link ${activeTab === tab.id ? 'active' : ''}`} onClick={() => setActiveTab(tab.id)}>{tab.label}</button></li>))}
              </ul>
            </div>

            {/* Content Divs Below Tabs */}
            <div className="tab-content mt-3 w-100">
              {renderContent()}
            </div>
          </div>
        </section>
    </div>
  );
};

function Footprint() {
    const { inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();  // Access the authentication state
    return (
        <div className="container-fluid">
            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                body {
                font-family: 'Roboto';
                }
                .container-fluid {
                    padding-right: 0 !important;
                    padding-left: 0 !important;
                }
                .home-banner img {
                    display: block;
                    margin: 0 auto;
                }
                `}
            </style>
           {/* Banner Image: Only visible when Home link is active */}
           <div className="home-banner">
          <img src="/Banner 7.png" alt="Footprint Banner" style={{ width: '100%', height: '350px', objectFit: 'cover' }}/>
         </div>   
            <div className="footprintpage" style={{paddingBottom: '2em'}}>
            <AuthenticatedTemplate>          
                <FootprintCalculator /> {/* FootprintCalculator component included here */}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <section id="footprint" className="container-fluid" >
                    <div className="container">               
                    <p style={{ color: '#000', paddingTop: '1em', paddingBottom: '10px' }}><strong>Please login or register to continue.</strong></p>
                    <SignInButton />
                    </div>
                </section>
                  {/* Routes for Unauthenticated Users */}
                    {!isAuthenticated && (
                        <Routes>
                        <Route path="/gloria-mrio" element={<GloriaMrio />} />
                        <Route path="/metadata" element={<Metadata />} />
                        <Route path="/Guidelines" element={<Guidelines />} />
                        <Route path="/contact-us" element={<ContactUs />} />
                        <Route path="/calculator" element={<Footprint />} />
                        </Routes>
                    )}
            </UnauthenticatedTemplate>
            </div>
        </div>
    );
}

export default Footprint;
